//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";

export default {
    name: "AppSpecificGroups",
    components: {
        RolesUsersTable: () => import(
            "@/components/Admin/RolesAndUsers/RolesAndUsersTable/rolesAndUsersTable.vue"
        )
    },
    data() {
        return {
            readonly: false
        };
    },
    computed: {
        ...mapGetters("admin", ["getAppGroupsInitialData"])
    },
    created() {
        this.checkPermissions();
        this.$root.$on("oneAtATime-appSpecificGroups", () => {
            this.checkPermissions({ readonly: !this.$oneAtATime.state.$currentRoomEmpty });
        });
    },
    activated() {
        this.checkPermissions();
    },
    deactivated() {
        this.$store.commit("main/setSaveBtnVisible", false);
        this.$root.$emit("setReadonlyTag", false);
    },
    beforeDestroy() {
        this.$store.commit("admin/appSettingsData");
        this.$store.commit("admin/setGroupsAppList");
    },
    methods: {
        ...mapMutations("main", ["setInterfaceDirty", "setGroupsAppList"]),
        ...mapMutations("admin", ["appSettingsData"]),
        showNotification() {
            this.$toast.showNotify({
                type: "success",
                message: this.$t("generic.saved")
            });
        },
        checkPermissions(oneAtATimeParams) {
            const isReadonly = this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly;
            if (isReadonly) {
                this.readonly = true;
            } else if (oneAtATimeParams && oneAtATimeParams.hasOwnProperty("readonly")) {
                this.readonly = oneAtATimeParams.readonly;
            } else {
                this.readonly = false;
            }
            this.$store.commit("main/setSaveBtnVisible", this.readonly);
            this.$root.$emit("setReadonlyTag", this.readonly);
        }
    }
};
